import { useContext } from "react";

import { OakStreamClientContext } from "./context";

/**
 * Returns the cached oak-stream client when called inside an
 * `OakStreamClientProvider`, or `null` otherwise.
 *
 * The hook intentionally does not throw when the provider is missing because
 * `<NotificationBell>` (and anything else that subscribes via `useOakStream`)
 * gets rendered inside the top-level `<Oops />` error fallback. That fallback
 * lives above `<App>` in the route tree, so the provider is unavailable. Throwing
 * here would crash the error fallback itself and produce a blank page on any
 * transient network failure (e.g. dev server still booting after sleep). Returning
 * `null` lets `useOakStream` no-op gracefully and the rest of the chrome render.
 */
export function useOakStreamClient() {
  return useContext(OakStreamClientContext);
}
